/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M9 8.99976L9 14.9998M6 10.9998L6 12.9998M12 6.99976L12 16.9998M15 8.99976L15 14.9998M18 10.9998V12.9998"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<rect
				x="2"
				y="2"
				width="20"
				height="20"
				rx="5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<rect
				opacity="0.12"
				x="1.75"
				y="1.75"
				width="20"
				height="20"
				rx="5"
				fill="currentColor"
			/>
			<path
				d="M8.75 8.75V14.75M5.75 10.75V12.75M11.75 6.75V16.75M14.75 8.75V14.75M17.75 10.75V12.75M9.75 21.75H13.75C16.5503 21.75 17.9504 21.75 19.02 21.205C19.9608 20.7257 20.7257 19.9608 21.205 19.02C21.75 17.9504 21.75 16.5503 21.75 13.75V9.75C21.75 6.94974 21.75 5.54961 21.205 4.48005C20.7257 3.53924 19.9608 2.77433 19.02 2.29497C17.9504 1.75 16.5503 1.75 13.75 1.75H9.75C6.94974 1.75 5.54961 1.75 4.48005 2.29497C3.53924 2.77433 2.77433 3.53924 2.29497 4.48005C1.75 5.54961 1.75 6.94974 1.75 9.75V13.75C1.75 16.5503 1.75 17.9504 2.29497 19.02C2.77433 19.9608 3.53924 20.7257 4.48005 21.205C5.54961 21.75 6.94974 21.75 9.75 21.75Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.98005 1.79497C5.04961 1.25 6.44974 1.25 9.25 1.25L14.75 1.25C17.5503 1.25 18.9504 1.25 20.02 1.79497C20.9608 2.27434 21.7257 3.03924 22.205 3.98005C22.75 5.04961 22.75 6.44974 22.75 9.25L22.75 14.75L22.75 14.75C22.75 17.5503 22.75 18.9504 22.205 20.02C21.7257 20.9608 20.9608 21.7257 20.02 22.205C18.9504 22.75 17.5503 22.75 14.75 22.75L9.25 22.75C6.44974 22.75 5.04961 22.75 3.98005 22.205C3.03924 21.7257 2.27433 20.9608 1.79497 20.02C1.25 18.9504 1.25 17.5503 1.25 14.75L1.25 9.25C1.25 6.44974 1.25 5.04961 1.79497 3.98005C2.27433 3.03924 3.03924 2.27434 3.98005 1.79497ZM12.75 7.00024C12.75 6.58603 12.4142 6.25024 12 6.25024C11.5858 6.25024 11.25 6.58603 11.25 7.00024L11.25 17.0002C11.25 17.4145 11.5858 17.7502 12 17.7502C12.4142 17.7502 12.75 17.4145 12.75 17.0002L12.75 7.00024ZM9.74997 9.00024C9.74997 8.58603 9.41418 8.25024 8.99997 8.25024C8.58575 8.25024 8.24997 8.58603 8.24997 9.00024L8.24997 15.0002C8.24997 15.4145 8.58575 15.7502 8.99997 15.7502C9.41418 15.7502 9.74997 15.4145 9.74997 15.0002L9.74997 9.00024ZM15.75 9.00024C15.75 8.58603 15.4142 8.25024 15 8.25024C14.5858 8.25024 14.25 8.58603 14.25 9.00024L14.25 15.0002C14.25 15.4145 14.5858 15.7502 15 15.7502C15.4142 15.7502 15.75 15.4145 15.75 15.0002L15.75 9.00024ZM6.74997 11.0002C6.74997 10.586 6.41418 10.2502 5.99997 10.2502C5.58575 10.2502 5.24997 10.586 5.24997 11.0002L5.24997 13.0002C5.24997 13.4145 5.58575 13.7502 5.99997 13.7502C6.41418 13.7502 6.74997 13.4145 6.74997 13.0002L6.74997 11.0002ZM18.75 11.0002C18.75 10.586 18.4142 10.2502 18 10.2502C17.5858 10.2502 17.25 10.586 17.25 11.0002L17.25 13.0002C17.25 13.4145 17.5858 13.7502 18 13.7502C18.4142 13.7502 18.75 13.4145 18.75 13.0002L18.75 11.0002Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M9.5 2L9 2V2C7.13872 2 6.20808 2 5.45492 2.24472C3.93273 2.73931 2.73931 3.93273 2.24472 5.45492C2 6.20808 2 7.13872 2 9L2 14C2 16.8003 2 18.2004 2.54497 19.27C3.02434 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V9C22 7.13872 22 6.20808 21.7553 5.45492C21.2607 3.93273 20.0673 2.73931 18.5451 2.24472C17.7919 2 16.8613 2 15 2V2L14.5 2M9 9V15M6 11V13M12 7V17M15 9V15M18 11V13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M9 9V15M6 11V13M12 7V17M15 9V15M18 11V13M10 22H14C16.8003 22 18.2004 22 19.27 21.455C20.2108 20.9757 20.9757 20.2108 21.455 19.27C22 18.2004 22 16.8003 22 14V10C22 7.19974 22 5.79961 21.455 4.73005C20.9757 3.78924 20.2108 3.02433 19.27 2.54497C18.2004 2 16.8003 2 14 2H10C7.19974 2 5.79961 2 4.73005 2.54497C3.78924 3.02433 3.02433 3.78924 2.54497 4.73005C2 5.79961 2 7.19974 2 10V14C2 16.8003 2 18.2004 2.54497 19.27C3.02433 20.2108 3.78924 20.9757 4.73005 21.455C5.79961 22 7.19974 22 10 22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M9.25 1.25C6.44974 1.25 5.04961 1.25 3.98005 1.79497C3.03924 2.27433 2.27433 3.03924 1.79497 3.98005C1.25 5.04961 1.25 6.44974 1.25 9.25V14.75C1.25 17.5503 1.25 18.9504 1.79497 20.02C2.27433 20.9608 3.03924 21.7257 3.98005 22.205C5.04961 22.75 6.44974 22.75 9.25 22.75H14.75C17.5503 22.75 18.9504 22.75 20.02 22.205C20.9608 21.7257 21.7257 20.9608 22.205 20.02C22.75 18.9504 22.75 17.5503 22.75 14.75V9.25C22.75 6.44974 22.75 5.04961 22.205 3.98005C21.7257 3.03924 20.9608 2.27433 20.02 1.79497C18.9504 1.25 17.5503 1.25 14.75 1.25H9.25Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 6.25025C12.4142 6.25025 12.75 6.58603 12.75 7.00025L12.75 17.0002C12.75 17.4145 12.4142 17.7502 12 17.7502C11.5858 17.7502 11.25 17.4145 11.25 17.0002L11.25 7.00025C11.25 6.58603 11.5858 6.25025 12 6.25025ZM9 8.25025C9.41421 8.25025 9.75 8.58603 9.75 9.00025L9.75 15.0002C9.75 15.4145 9.41421 15.7502 9 15.7502C8.58579 15.7502 8.25 15.4145 8.25 15.0002L8.25 9.00025C8.25 8.58603 8.58579 8.25025 9 8.25025ZM15 8.25025C15.4142 8.25025 15.75 8.58603 15.75 9.00025L15.75 15.0002C15.75 15.4145 15.4142 15.7502 15 15.7502C14.5858 15.7502 14.25 15.4145 14.25 15.0002L14.25 9.00025C14.25 8.58603 14.5858 8.25025 15 8.25025ZM6 10.2502C6.41421 10.2502 6.75 10.586 6.75 11.0002L6.75 13.0002C6.75 13.4145 6.41421 13.7502 6 13.7502C5.58579 13.7502 5.25 13.4145 5.25 13.0002L5.25 11.0002C5.25 10.586 5.58579 10.2502 6 10.2502ZM18 10.2502C18.4142 10.2502 18.75 10.586 18.75 11.0002L18.75 13.0002C18.75 13.4145 18.4142 13.7502 18 13.7502C17.5858 13.7502 17.25 13.4145 17.25 13.0002L17.25 11.0002C17.25 10.586 17.5858 10.2502 18 10.2502Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
